import React from "react";
import PeakBrandMark from "./PeakBrandMark";

interface OnboardingProgressBarProps {
  filled: number;
  total?: number;
  inverted?: boolean;
}

/** 4 capsules 22×6, 6px gap; filled = brand, empty = bg-secondary (white 28% inverted). */
export const OnboardingProgressBar: React.FC<OnboardingProgressBarProps> = ({
  filled,
  total = 4,
  inverted = false,
}) => (
  <div className="flex items-center gap-1.5" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={total}>
    {Array.from({ length: total }).map((_, index) => (
      <span
        key={index}
        className={`block h-1.5 w-[22px] rounded-full transition-colors duration-200 ${
          index < filled
            ? inverted ? "bg-white" : "bg-peak-brand"
            : inverted ? "bg-white/[0.28]" : "bg-peak-bg-secondary"
        }`}
      />
    ))}
  </div>
);

interface OnboardingStepHeaderProps {
  showBack?: boolean;
  progress?: number | null;
  inverted?: boolean;
  accessory?: React.ReactNode;
  onBack?: () => void;
  /** The desktop side panel already carries the wordmark. */
  hideBrandOnDesktop?: boolean;
}

/** Back chevron (28×44 hit box) + brand mark, optional 4-capsule progress on the right. */
const OnboardingStepHeader: React.FC<OnboardingStepHeaderProps> = ({
  showBack = true,
  progress = null,
  inverted = false,
  accessory,
  onBack,
  hideBrandOnDesktop = false,
}) => (
  <div className="flex min-h-[44px] w-full items-center gap-4">
    <div className="flex items-center gap-2">
      {showBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Back"
          className={`flex h-11 w-7 items-center justify-start ${inverted ? "text-white" : "text-peak-text"}`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M15 5l-7 7 7 7" />
          </svg>
        </button>
      )}
      <PeakBrandMark inverted={inverted} className={hideBrandOnDesktop ? "lg:hidden" : ""} />
    </div>
    <div className="flex-1" />
    {progress !== null && progress !== undefined ? (
      <OnboardingProgressBar filled={progress} total={4} inverted={inverted} />
    ) : (
      accessory
    )}
  </div>
);

export default OnboardingStepHeader;
